module.exports = __webpack_public_path__ + "img/soccer_w.21dfe28e.svg";